const realEstatePropertyChilds = [
  // 会员管理
  {
    path: "pmanage",
    name: "PManage",
    component: () => import("@/views/realEstateProperty/pmanage.vue"),
    children: [
      {
        path: "pmember",
        name: "Pmember",
        component: () => import("@/views/realEstateProperty/children/pmember.vue"),
      },
      // 积分抵扣
      {
        path: "ppointsDeduc",
        name: "PpointsDeduc",
        component: () => import("@/views/realEstateProperty/children/ppointsDeduc.vue"),
      },
      // 积分结算
      {
        path: "ppointsSettle",
        name: "PpointsSettle",
        component: () => import("@/views/realEstateProperty/children/ppointsSettle.vue"),
      },
    ]
  },
  // 认证列表
  {
    path: "authentication",
    name: "Authentication",
    component: () => import("@/views/realEstateProperty/authentication.vue"),
    children: [
      {
        path: "authenticationList",
        name: "AuthenticationList",
        component: () => import("@/views/realEstateProperty/children/authenticationList.vue"),
      },
    ],
  },
];
export default realEstatePropertyChilds;
